module.exports = __webpack_public_path__ + "assets/e24d80f97f031219f830bff6210515e9.png";